/**
 * Centralized route configuration for the application
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  
  // Guest routes
  GUEST: {
    INFO: '/guest/info',
    TEST: (sessionId: string) => `/guest/test/${sessionId}`,
    RESULTS: (sessionId: string) => `/guest/results/${sessionId}`,
  },

  // Kiosk routes
  KIOSK: {
    START: '/kiosk/start',
    TEST: (testId: string) => `/kiosk/test/${testId}`,
    RESULTS: (testId: string) => `/kiosk/results/${testId}`,
  },
  
  // User type detection
  DASHBOARD_REDIRECT: '/dashboard',
  
  // Admin routes
  ADMIN: {
    BASE: '/admin',
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    TEST: '/admin/test',
    RESULTS: (testId: string) => `/admin/results/${testId}`,
    ANALYTICS: '/admin/analytics',
    CONFIGURATION: '/admin/configuration',
    REPORTS: '/admin/reports',
    PROFILE: '/admin/profile',
  },
} as const;

/**
 * Route permissions configuration
 */
export const ROUTE_PERMISSIONS = {
  PUBLIC: [
    ROUTES.HOME,
    ROUTES.LOGIN,
    ROUTES.GUEST.INFO,
    ROUTES.KIOSK.START,
  ],
  
  GUEST_ONLY: [
    ROUTES.GUEST.INFO,
    '/guest/test/*',
    '/guest/results/*',
    '/kiosk/*',
  ],
  
  AUTHENTICATED_ONLY: [
    ROUTES.DASHBOARD_REDIRECT,
    '/admin/*',
  ],
  
  ADMIN_ONLY: [
    ROUTES.ADMIN.BASE,
    ROUTES.ADMIN.DASHBOARD,
    ROUTES.ADMIN.USERS,
    ROUTES.ADMIN.TEST,
    ROUTES.ADMIN.ANALYTICS,
    '/admin/*',
  ],
  
} as const;

/**
 * Navigation menu items based on user role
 */
export const getNavigationItems = (userRole: 'admin' | 'superadmin' | null) => {
  const baseItems = [
    { label: 'Home', path: ROUTES.HOME },
  ];
  
  switch (userRole) {
    case 'admin':
    case 'superadmin':
      return [
        ...baseItems,
        { label: 'Dashboard', path: ROUTES.ADMIN.DASHBOARD },
        { label: 'Test Setup', path: ROUTES.ADMIN.TEST },
        { label: 'Analytics', path: ROUTES.ADMIN.ANALYTICS },
      ];
      
    default:
      return baseItems;
  }
};
